import {IRecommendations} from '../interface';
import _ from 'lodash';

const findProductionsById = (productions: IRecommendations[], id: number) => {
  return _.find(
    _.uniqBy(
      _.compact(
        _.flatMapDeep(
          _.map(productions, (production) =>
            _.concat(
              production.alternateProducts,
              production.recommendedProduct,
            ),
          ),
        ),
      ),
      'id',
    ),
    (o) => _.isEqual(o['id'], id),
  );
};

export default findProductionsById;
